const isIosDevice = () => {
  const userAgent = navigator.userAgent || ''

  const classicIosDevice =
    /iPad|iPhone|iPod/i.test(userAgent)

  /*
   * Nowszy iPadOS może przedstawiać się jako macOS.
   */
  const ipadPretendingToBeMac =
    navigator.platform === 'MacIntel'
    && navigator.maxTouchPoints > 1

  return classicIosDevice || ipadPretendingToBeMac
}

const isStandalonePwa = () => {
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || navigator.standalone === true
  )
}

const isIosPwa = () => {
  return isIosDevice() && isStandalonePwa()
}

/**
 * Existing, classic download.
 */
const classicDownload = (blob, filename) => {
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = blobUrl
  link.download = filename
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()
  link.remove()

  /*
    * We do not release the address immediately, as Safari may
    * still be reading the Blob after link.click() has been executed.
   */
  setTimeout(() => {
    URL.revokeObjectURL(blobUrl)
  }, 60_000)

  return true
}

/**
 * An alternative solution used exclusively in iOS PWAs.
 */
const saveInIosPwa = async (blob, filename) => {
  if (typeof navigator.share !== 'function') {
    console.warn('Web Share API nie jest dostępne w tym iOS PWA')

    return classicDownload(blob, filename)
  }

  const file = new File([blob], filename, {
    type: blob.type || 'application/octet-stream',
    lastModified: Date.now(),
  })

  const canShareFile =
    typeof navigator.canShare !== 'function'
    || navigator.canShare({ files: [file] })

  if (!canShareFile) {
    console.warn(
      `iOS nie pozwala udostępnić pliku typu: ${file.type}`,
    )

    return classicDownload(blob, filename)
  }

  try {
    await navigator.share({
      files: [file],
      title: filename,
    })

    return true
  } catch (error) {
    /*
     * The user has closed the system menu.
     * In this case, we do not automatically start the download.
     */
    if (error?.name === 'AbortError')
      return false

    console.error(
      'Nie udało się otworzyć zapisywania pliku w iOS PWA:',
      error,
    )

    /*
     *  We’re leaving the fallback in place in case of other errors.
     */
    return classicDownload(blob, filename)
  }
}

export const saveBlob = async (blob, filename) => {
  if (!(blob instanceof Blob))
    throw new TypeError('Oczekiwano obiektu Blob')

  if (!filename)
    throw new TypeError('Nie podano nazwy pliku')

  /*
   * We are launching the other solution exclusively on iOS PWA.
   */
  if (isIosPwa())
    return saveInIosPwa(blob, filename)

  /*
   * Safari, Android, desktop and other platforms
   * continue to use the existing mechanism.
   */
  return classicDownload(blob, filename)
}
